import PropTypes from 'prop-types';
import { INLINES } from '@contentful/rich-text-types';
import { v4 as uuidv4 } from 'uuid';

import RichText from '../RichText';
import CtaTextLink from '../CtaTextLink';

import { ParagraphContent, Content, Bubble } from './styles';

const ParagraphContentSection = ({ size, data, themes }) => {
  const { heading, bodyCopy, marginType, styledContent } = data;

  const linkRawOptions = {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => {
        const {
          data: { uri },
        } = node;
        return (
          <CtaTextLink
            key={`${uuidv4()}-${uri}`}
            url={uri}
            inline
            className="content"
            themes={themes}
          >
            {children}
          </CtaTextLink>
        );
      },
    },
  };

  return (
    <ParagraphContent>
      <Content size={size} className={marginType} styledContent={styledContent}>
        {heading && <RichText document={heading} />}
        {styledContent
          ? bodyCopy && (
              <Bubble themes={themes}>
                <RichText document={bodyCopy} options={linkRawOptions} />
              </Bubble>
            )
          : bodyCopy && (
              <RichText document={bodyCopy} options={linkRawOptions} />
            )}
      </Content>
    </ParagraphContent>
  );
};

ParagraphContentSection.propTypes = {
  size: PropTypes.string,
  data: PropTypes.shape().isRequired,
  themes: PropTypes.string.isRequired,
};

ParagraphContentSection.defaultProps = {
  size: 'xl',
};

export default ParagraphContentSection;
